/** @flow */

import React from "react";
import config from "@config";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  DatePicker,
  Icon,
  ComboBox,
} from "@components";
import type { ManualReferralTaskData } from "@modules/shared/reducer/employee-events/types";
import type { ReferralQuestionAnswerType } from "@modules/shared/reducer/types";

type Props = $Exact<{
  data: ManualReferralTaskData,
  toggleModal?: Function,
  t: Function,
}>;

export class ManualReferralTaskModal extends React.Component<Props> {
  get data(): ManualReferralTaskData {
    return this.props.data;
  }

  generateQuestionField = (qa: ReferralQuestionAnswerType) => {
    const answer = qa.answer && qa.answer.value;
    // Don't know how to check this modal. Need help from qa
    switch (qa.question.questionType) {
      case "CONFIRMATION":
        return <div />;
      case "FREE_TEXT":
        return <Input value={answer} disabled />;
      case "DATE_PICK":
        return <DatePicker disabled dateFormat={config.dateTimeFormat} value={answer} />;
      case "MULTI_SELECT":
        return (
          <ComboBox
            disabled
            isMulti
            value={
              answer && answer.map
                ? answer.map(val => {
                    return { value: val, label: val };
                  })
                : []
            }
            options={qa.question.selectableValues}
          />
        );
      case "SINGLE_SELECT":
        return (
          <ComboBox
            disabled
            value={{
              value: answer,
              label: answer,
            }}
            options={[qa.question.selectableValues]}
          />
        );
    }
    return true;
  };
  generateQuestions = () => {
    return this.data.questionAnswers.map((qa: Object) => {
      return (
        <div key={qa.question.id} className={"mb-4"}>
          {qa.question.questionText}
          {qa.question.isMandatory && (
            <Icon icon="asterisk" size="xs" className="text-warning ml-2" />
          )}
          {this.generateQuestionField(qa)}
        </div>
      );
    });
  };

  render(): React$Node {
    return (
      <Modal className={"referral-decision-modal"}>
        <ModalHeader>
          {this.props.t("ACTIVITY_HISTORY_ITEM_TITLE", {
            id: this.data.id,
            type: this.props.t("MANUAL_REFERRAL"),
          })}
        </ModalHeader>

        <ModalBody>
          <div className={"mb-4 font-weight-bold"}>
            {this.props.t("SUPPLIER_NAME")}
            <Input disabled={true} value={this.data.supplierName} />
          </div>
          <div className={"mb-4 font-weight-bold"}>
            {this.props.t("REASON_FOR_REFERRAL")}
            <ComboBox
              disabled
              value={{ value: this.data.reason.reason, label: this.data.reason.reason }}
              options={[{ value: this.data.reason.reason, label: this.data.reason.reason }]}
            />
          </div>

          <div className={"mb-4 font-weight-bold"}>{this.props.t("Referral questions")}</div>
          {this.generateQuestions()}
        </ModalBody>
        <ModalFooter>
          <Button onClick={this.props.toggleModal}>{this.props.t("CANCEL")}</Button>
        </ModalFooter>
      </Modal>
    );
  }
}

export default ManualReferralTaskModal;
